// extracted by mini-css-extract-plugin
export default {"metaInfo":"VUfgOR","metaItem":"_jGDrj"};